import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { MessageService } from '../services/message.service';
import { KmlService } from '../services/kml.service';
import { MapService } from '../services/map.service';
import { MarkersService } from '../services/markers.service';
import { Route } from '../interfaces/route';
import { Trip } from '../interfaces/trip';
import { timer } from 'rxjs';
import { GlobalVariables } from '../common/global-variables';

const railTripUrl = "https://www3.septa.org/api/TrainView/";
const busTripUrl = "https://www3.septa.org/api/TransitViewAll/";

const rail_routes: any = Array("AIR", "CHE", "CHW", "LAN", "MED", "FOX", "NOR", "PAO", "CYN", "TRE", "WAR", "WIL", "WTR", "GC");

@Injectable({
  providedIn: 'root'
})
export class TripsService {
  public selectedTrip: any;
  public selectedRoute: any;
  private data: any = [];
  public transitRefresh: any;

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(private http: HttpClient, private messageService: MessageService, private mapService: MapService, private kmlService: KmlService, private markersService: MarkersService) {
    this.selectedTrip = { id: "562", route: "Trenton", routeID: 'TRE', mode: "Regional Rail" };

    var selectedTrip = JSON.parse(localStorage.getItem("selectedTrip"));
    if (selectedTrip != null) {
      this.selectedTrip = selectedTrip;
    }

    this.selectedRoute = { id: this.selectedTrip.routeID, name: this.selectedTrip.route, mode: this.selectedTrip.mode };
  }

  /** GET trips from api */
  get(selected_trip: string = "", mode: string = "", route_id: string = ""): Observable<any[]> {

    //Clear previous markers
    this.markersService.clearMarkers(this.mapService.map);

    var url = GlobalVariables.railTripsUrl;

    if(selected_trip != ""){

      if(selected_trip.slice(-1) == 'D'){
        selected_trip = selected_trip.slice(0, -1);        
      }

      url = GlobalVariables.railTripsUrl + "?train=" + selected_trip;
    }

    if (mode == "bus") {
      url = GlobalVariables.busTripsUrl;
    }

    this.data = this.http.jsonp<Route[]>(url, 'callback')
      .pipe(
        map((array: any) => array = this.transform(array, selected_trip, mode, route_id)),
        tap(_ => this.log('fetched routes')),
        catchError(this.handleError<Route[]>('get', []))
      );

    return this.data;
  }

  detail(trip: Trip) {
    this.selectedTrip = trip;
    this.selectedRoute = { id: this.selectedTrip.routeID, name: this.selectedTrip.route, mode: this.selectedTrip.mode };
    localStorage.setItem("selectedTrip", JSON.stringify(trip));
  }

  private transform(response: any, selected_trip: string = "", mode: string = "", route_id: string = ""): any {
    var transformed: any[] = [];


    if (mode == 'bus') {
      response = response["routes"][0][route_id];
    }

    for (const trip of response) {

      if (mode == 'bus') {
        this.selectedRoute = { id: route_id, name: route_id, mode: 'Bus' };

        this.kmlService.get(this.mapService.map, this.selectedRoute);

        if(selected_trip != "" && selected_trip == trip.trip){
          this.transitRefresh = timer(1000, 5000).subscribe(t => {
            this.markersService.fetch(this.mapService.map, this.selectedRoute, selected_trip);
          });
  
        }
        
        if(selected_trip == "" ){
          this.transitRefresh = timer(1000, 5000).subscribe(t => {
            this.markersService.fetch(this.mapService.map, this.selectedRoute, selected_trip);
          });
        }

        const status = trip.late == 0 ? 'On-time' : trip.late > 0 ? trip.late + " mins late" : trip.late + ' mins early';

        transformed.push({
          id: trip.trip,
          route: trip.line,
          routeID: route_id,
          block: trip.BlockID,
          mode: 'Bus',
          type: trip.service,
          origin: trip.SOURCE,
          destination: trip.dest,
          currentstop: trip.next_stop_name,
          nextstop: trip.next_stop_name,
          delay: trip.late,
          status: status,
          vehicle: trip.consist,
          cars: trip.VehicleID,
          heading: trip.heading,
          lat: trip.lat,
          lon: trip.lng
        });
      }
      else {
        if (trip.trainno.trim() == selected_trip) {

          this.selectedRoute = { id: this.get_route_id(trip.line), name: trip.line, mode: 'Regional Rail' };
          this.kmlService.get(this.mapService.map, this.selectedRoute);



          this.transitRefresh = timer(1000, 5000).subscribe(t => {
            this.markersService.fetch(this.mapService.map, this.selectedRoute, selected_trip);
          });

          const cars = trip.consist.split(",").length;
          const status = trip.late == 0 ? 'On-time' : trip.late > 0 ? trip.late + " mins late" : trip.late + ' mins early';

          transformed.push({
            id: trip.trainno,
            route: trip.line,
            routeID: this.convertRouteToID(trip.line) + 'd',
            block: trip.trainno,
            mode: 'Regional Rail',
            type: trip.service,
            origin: trip.SOURCE,
            destination: trip.dest,
            currentstop: trip.currentstop,
            nextstop: trip.nextstop,
            delay: trip.late,
            status: status,
            vehicle: trip.consist,
            cars: cars != 0 ? cars : 1,
            heading: trip.heading,
            lat: trip.lat,
            lon: trip.lon
          });
        }
      }
    }

    return transformed;
  }

  private get_route_id(name: string): string {

    switch (name) {
      case 'Airport':
        name = 'AIR';
        break;
      case 'Chestnut Hill East':
        name = 'CHE';
        break;
      case 'Chestnut Hill West':
        name = 'CHW';
        break;
      case 'Cynwyd':
        name = 'CYN';
        break;
      case 'Fox Chase':
        name = 'FOX';
        break;
      case 'Glenside Combined':
        name = 'GLN';
        break;
      case 'Lansdale/Doylestown':
        name = 'LAN';
        break;
      case 'Manayunk/Norristown':
        name = 'NOR';
        break;
      case 'Media/Wawa':
        name = 'MED';
        break;
      case 'Paoli/Thorndale':
        name = 'PAO';
        break;
      case 'Trenton':
        name = 'TRE';
        break;
      case 'Warminster':
        name = 'WAR';
        break;
      case 'Wilmington/Newark':
        name = 'WIL';
        break;
      case 'West Trenton':
        name = 'WTR';
        break;

    }

    return name;
  }

  private convertRouteToID(name: string): string {
    const prefixRail = 'rr_route_'

    switch (name) {
      case 'Airport':
        name = prefixRail + 'apt';
        break;
      case 'Chestnut Hill East':
        name = prefixRail + 'che';
        break;
      case 'Chestnut Hill West':
        name = prefixRail + 'chw';
        break;
      case 'Cynwyd':
        name = prefixRail + 'cyn';
        break;
      case 'Fox Chase':
        name = prefixRail + 'fxc';
        break;
      case 'Glenside Combined':
        name = prefixRail + 'gc';
        break;
      case 'Lansdale/ Doylestown':
        name = prefixRail + 'landdoy';
        break;
      case 'Manayunk/Norristown':
        name = prefixRail + 'nor';
        break;
      case 'Media/Wawa':
        name = prefixRail + 'med';
        break;
      case 'Paoli/Thorndale':
        name = prefixRail + 'pao';
        break;
      case 'Trenton':
        name = prefixRail + 'trent';
        break;
      case 'Warminster':
        name = prefixRail + 'warm';
        break;
      case 'Wilmington/ Newark':
        name = prefixRail + 'wilm';
        break;
      case 'West Trenton':
        name = prefixRail + 'wtren';
        break;

    }

    return name;
  }

  public get_trips(route_id: string) {

    var url = busTripUrl;

    if (rail_routes.includes(route_id)) {
      url = railTripUrl;
    }

    this.data = this.http.jsonp<Route[]>(url, 'callback')
      .pipe(
        map((array: any) => array = this.transform_trips(array, route_id)),
        tap(_ => this.log('fetched routes')),
        catchError(this.handleError<Route[]>('get', []))
      );

    return this.data;
  }

  private transform_trips(response: any, route: string) {
    var transformed: any[] = [];

    if (rail_routes.includes(route)) {
      for (const trip of response) {
        const cars = trip.consist.split(",").length;
        var status = trip.late == 0 ? 'On-time' : trip.late > 0 ? trip.late + " min late" : Math.abs(trip.late) + ' min early';
        status = trip.late == 999 ? 'Canceled' : trip.late == 998 ? "Untracked" : status;
        var vehicle = trip.consist == 0 ? null : trip.consist.replaceAll(",", ", ");

        transformed.push({
          route: trip.line,
          route_id: this.get_route_id(trip.line),
          block_id: trip.trainno,
          trip_id: trip.trainno,
          mode: 'Regional Rail',
          type: trip.service,
          origin: trip.SOURCE,
          destination: trip.dest,
          currentstop: trip.currentstop,
          next_stop_name: trip.nextstop,
          delay: trip.late,
          status: status,
          vehicle: vehicle,
          cars: cars != 0 ? cars : 1,
          heading: trip.heading,
          estimated_seat_availability: "Not available",
          lat: trip.lat,
          lon: trip.lon
        });
      }
    }
    else {
      
      var trips : any = [];

      if(response["routes"][0][route] != undefined){
        trips = response["routes"][0][route];
      }

      for (const trip of trips) {
        var status = trip.late == 0 ? 'On-time' : trip.late > 0 ? trip.late + " min late" : Math.abs(trip.late) + ' min early';
        status = trip.late == 999 ? 'Canceled' : trip.late == 998 ? "Untracked" : status;
        var vehicle = trip.VehicleID == 0 ? null : trip.VehicleID.replace(",", ", ");

        transformed.push({
          route: route,
          route_id: route,
          block_id: trip.BlockID,
          trip_id: trip.trip,
          mode: 'Bus',
          origin: trip.Direction,
          destination: trip.destination,
          next_stop_name: trip.next_stop_name,
          next_stop_sequence: trip.next_stop_sequence,
          delay: trip.late,
          status: status,
          vehicle: vehicle,
          cars: 1,
          heading: trip.heading,
          estimated_seat_availability: trip.estimated_seat_availability,
          lat: trip.lat,
          lon: trip.lng
        });
      }

    }

    return transformed;
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log('${operation} failed: ${error.message}');

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  /** Log a RouteService message with the MessageService */
  private log(message: string) {
    this.messageService.add(`RouteService: ${message}`);
  }
}